
import React, { useState, useEffect } from "react";
import { getSignRequestsBySource } from "../services/signRequestService";
import type { SignRequest, SignSourceType } from "../../../types/signRequest";
import { SignRequestFormModal } from "./SignRequestFormModal";
import { SignRequestDetailModal } from "./SignRequestDetailModal";
import { Modal } from "../../../components/Modal";

interface Props {
  sourceType: SignSourceType;
  sourceId: string;
  sourceTitle: string;
  defaultCategory?: string;
}

export function SignRequestButton({ sourceType, sourceId, sourceTitle, defaultCategory = "一般簽呈" }: Props) {
  const [requests, setRequests] = useState<SignRequest[]>([]);
  const [loading, setLoading] = useState(false);
  
  // Modals
  const [showCreate, setShowCreate] = useState(false);
  const [selectedReq, setSelectedReq] = useState<SignRequest | null>(null);
  const [showList, setShowList] = useState(false);

  const fetchRequests = async () => {
    if (!sourceId) return;
    setLoading(true);
    try {
        const data = await getSignRequestsBySource(sourceType, sourceId);
        setRequests(data);
    } catch(e) {
        console.error(e);
    } finally {
        setLoading(false);
    }
  };

  useEffect(() => {
    fetchRequests();
  }, [sourceId, sourceType]);

  const handleClick = (e: React.MouseEvent) => {
      e.stopPropagation();
      if (requests.length === 0) {
          setShowCreate(true);
      } else if (requests.length === 1) {
          setSelectedReq(requests[0]);
      } else {
          setShowList(true);
      }
  };

  const btnLabel = loading ? "..." : requests.length > 0 ? `查看簽呈 (${requests.length})` : "建立簽呈";
  const btnStyle: React.CSSProperties = requests.length > 0 
    ? { background: "transparent", border: "1px solid #8b5cf6", color: "#8b5cf6" }
    : { background: "rgba(255,255,255,0.1)", border: "1px solid #555", color: "#ccc" };

  return (
    <>
      <button 
        className="smallbtn" 
        style={{ fontSize: 11, padding: "2px 8px", ...btnStyle }}
        onClick={handleClick}
      >
        {btnLabel}
      </button>

      {/* Create Modal */}
      {showCreate && (
        <SignRequestFormModal 
           sourceInfo={{ sourceType, sourceId, sourceTitle, category: defaultCategory }}
           onClose={() => setShowCreate(false)}
           onSuccess={() => { fetchRequests(); setShowCreate(false); }}
        />
      )}

      {/* Detail Modal */}
      {selectedReq && (
        <SignRequestDetailModal 
           request={selectedReq}
           onClose={() => setSelectedReq(null)}
           onUpdate={() => { fetchRequests(); setSelectedReq(null); }}
        />
      )}

      {/* List Modal (if multiple) */}
      {showList && (
        <Modal title="簽呈列表" onClose={() => setShowList(false)} width={600}>
           <div style={{display:'flex', flexDirection:'column', gap:10}}>
              {requests.map(req => (
                  <div key={req.id} className="tile" style={{cursor:'pointer', display:'flex', justifyContent:'space-between'}} onClick={() => { setSelectedReq(req); setShowList(false); }}>
                      <div>
                          <div style={{fontWeight:'bold'}}>{req.title}</div>
                          <div style={{fontSize:12, color:'var(--muted)'}}>{new Date(req.createdAt?.toDate? req.createdAt.toDate() : req.createdAt).toLocaleString()}</div>
                      </div>
                      <div className="badge">{req.status}</div>
                  </div>
              ))}
           </div>
           <div style={{marginTop:20, textAlign:'right'}}>
               <button className="btn" style={{width:'auto'}} onClick={() => { setShowCreate(true); setShowList(false); }}>+ 建立新簽呈</button>
           </div>
        </Modal>
      )}
    </>
  );
}
